<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isNil(selectedTask) ? '작업 태스크 추가' : '작업 태스크 수정'" width="600px" @close="close()">
    <div slot="content">
      <!-- 태스크 목록 -->
      <div v-show="isNil(selectedTask)" class="mr-b25">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box title-h4 dot-title">태스크 목록</div>
          <div class="vertical-center-box" align="right">
            <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="taskTable" max-height="230" :column-default="columnDefault" :data="taskList" :columns="taskColumns" :total="taskTotal"
        :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-pointer" highlight-current-row remote pagination
        @row-click="onRowClick" @condition-change="loadData">
        </el-table-wrapper>
      </div>
      <!-- 선택한 태스크 정보 -->
      <div class="mr-b25">
        <el-row class="title-bar title-h4 dot-title">선택한 태스크 정보</el-row>
        <el-form :model="taskFormData" label-position="top" size="mini">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="태스크 아이디">
                <el-input :value="taskFormData.taskId" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="태스크 이름">
                <el-input :value="taskFormData.taskName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="수행순서">
            <el-input-number controls-position="right" width="50%" :min="1" v-model="taskFormData.executeIndex"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <!-- 변수 정보 -->
      <div class="mr-b25">
        <el-row class="title-bar title-h4 dot-title">변수 정보</el-row>
        <el-table :data="variableList" max-height="230">
          <el-table-column prop="variableId" label="변수 아이디" header-align="left" align="left"></el-table-column>
          <el-table-column prop="variableValue" label="변수 값" header-align="left" align="left">
            <template slot-scope="scope">
              <el-input v-if="isAddPopup" v-model="variableValues[scope.$index]" size="mini" :placeholder="scope.row.variableValue"></el-input>
              <el-input v-else v-model="scope.row.variableValue" size="mini"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 플랫폼 정보 -->
      <div>
        <el-row class="title-bar title-h4 dot-title">플랫폼 정보</el-row>
        <el-table :data="nodetypeList" max-height="230">
          <el-table-column v-for="col in nodetypeColumns" :key="col.prop" :prop="col.prop" :label="col.label" :formatter="col.formatter" header-align="left" align="left">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="saveButtonDisabled" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const nodeFormatter = (row, column, value) => {
  const nodetypeId = column.property;
  let cellValue = '';
  if (!isNil(row[`${nodetypeId}Name`])) {
    cellValue = row[`${nodetypeId}Name`];
  } else if (value === 'all') {
    cellValue = '전체';
  }
  return defaultFormatter(row, column, cellValue);
};

export default {
  name: 'WJobTaskSettingPopup',
  props: {
    selectedJob: {
      type: Object,
    },
    selectedTask: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      taskTotal: 0,
      taskColumns: [
        { prop: 'taskName', label: '태스크 이름', remoteProp: 'task.task_name', searchable: true, sortable: true },
        { prop: 'failoverJudgeType', label: '실패 판단 방법', remoteProp: 'task.failover_judge_type', searchable: true, sortable: true },
      ],
      nodetypeColumns: [
        { prop: 'os', label: 'OS', formatter: nodeFormatter },
        { prop: 'distributor', label: '공급자', formatter: nodeFormatter },
        { prop: 'version', label: '버전', formatter: nodeFormatter },
        { prop: 'arch', label: '아키텍처', formatter: nodeFormatter },
      ],
      taskList: [],
      taskFormData: {
        taskId: '',
        taskName: '',
        executeIndex: null,
      },
      variableList: [],
      nodetypeList: [],
      originalData: { task: null, variable: null },
      variableValues: [], // 추가 팝업) 변수 기본값은 placeholder로 제공, 별도의 값 설정 시 해당 리스트에 저장
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedTask);
    },
    saveButtonDisabled() {
      return !this.isAddPopup && isEqual(this.taskFormData, this.originalData.task) && isEqual(this.variableList, this.originalData.variable);
    },
  },
  methods: {
    isNil,
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.taskList = [];
      this.taskFormData = {
        taskId: '',
        taskName: '',
        executeIndex: null,
      };
      this.variableList = [];
      this.variableValues = [];
      this.showSearchTool = false;
      this.$refs.taskTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      const taskTable = this.$refs.taskTable;
      const tableParams = taskTable.getParameter();
      const params = this.isAddPopup ? { jobId: this.selectedJob.jobId } : { jobId: this.selectedJob.jobId, taskId: this.selectedTask.taskId };
      amsSettingsApi.getJobTaskSettingInfo({ ...params, ...tableParams }).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.taskList = result.taskInfo;
          this.taskTotal = response.data.data.taskInfoTotal;
          this.nodetypeList = response.data.data.nodetypeInfo;
          this.variableList = response.data.data.variables;
          if (!this.isAddPopup) {
            const selectedTask = this.taskList.length > 0 ? this.taskList[0] : null;
            this.variableList = response.data.data.variables;
            this.originalData = { task: selectedTask };
            this.onRowClick(selectedTask);
          } else {
            taskTable.$children[0].setCurrentRow(this.taskList[0]);
            this.onRowClick(this.taskList[0]);
          }
        }
      });
    },
    /**
     * 태스크 목록 row click
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowClick(row) {
      if (!isNil(row)) {
        const selectedTask = cloneDeep(row);
        this.taskFormData = !isNil(selectedTask.executeIndex) ? selectedTask : { executeIndex: null, ...selectedTask };
        if (this.isAddPopup) {
          this.variableList = selectedTask.variables;
        }
      }
    },
    /**
     * 저장 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onSaveButton() {
      const jobTaskParams = {
        jobId: this.selectedJob.jobId,
        taskId: this.taskFormData.taskId,
        executeIndex: this.taskFormData.executeIndex,
      };
      const jobTaskVariables = this.variableList.reduce((variables, value, index) => {
        if (this.isAddPopup && !isEmpty(this.variableValues[index])) {
          value.variableValue = this.variableValues[index];
        }
        variables.push({ jobId: this.selectedJob.jobId, taskId: this.taskFormData.taskId, ...value });
        return variables;
      }, []);
      const params = { jobId: this.selectedJob.jobId };
      if (this.isAddPopup || !isEqual(this.taskFormData, this.originalData.task)) {
        params.taskInfo = jobTaskParams;
      }
      if (this.isAddPopup || !isEqual(this.variableList, this.originalData.variable)) {
        params.variableInfos = jobTaskVariables;
      }
      amsSettingsApi.insertJobTaskVariable(params).then((response) => {
        const target = '작업 태스크';
        const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
        if (response.data.success) {
          this.close();
          this.$emit('re-load');
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/JobSetting/popup/JobTaskSettingPopup.vue